import { render, staticRenderFns } from "./vinEPCDatas.vue?vue&type=template&id=68779636&scoped=true&"
import script from "./vinEPCDatas.vue?vue&type=script&lang=js&"
export * from "./vinEPCDatas.vue?vue&type=script&lang=js&"
import style0 from "./vinEPCDatas.vue?vue&type=style&index=0&id=68779636&lang=less&scoped=true&"
import style1 from "./vinEPCDatas.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68779636",
  null
  
)

component.options.__file = "vinEPCDatas.vue"
export default component.exports